import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MatButtonModule } from '@angular/material/button';
// import { RegistraturaViewComponent } from './registratura-view/registratura-view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastrModule } from 'ngx-toastr';
import { NgxLoadingModule } from 'ngx-loading';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
// import { VerificareAutoComponent } from './ddru/ridicari-auto/verificare-auto/verificare-auto.component';

import { DdruModule } from './ddru/ddru.module'; './ddru/ddru.module'
import { RegistraturaOnlineModule } from './ddru/registratura-online/registratura-online.module'
import { PlatiBlocariAutoModule } from './ddru/blocari-auto/plati-blocari-auto/plati-blocari-auto.module'
import { VerificareAutoModule } from './ddru/ridicari-auto/verificare-auto/verificare-auto.module';
import { PlatiRidicariAutoModule } from './ddru/ridicari-auto/plati-ridicari-auto/plati-ridicari-auto.module';
import { DocumenteModule } from './ddru/documente/documente.module';

@NgModule({
    declarations: [
        AppComponent,
        // RegistraturaComponent,
        // VerificareAutoComponent
        // RegistraturaViewComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        MatButtonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        BrowserAnimationsModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        NgxLoadingModule.forRoot({}),
        ToastrModule.forRoot(),
        MatAutocompleteModule,
        DdruModule,
        RegistraturaOnlineModule,
        PlatiBlocariAutoModule,
        VerificareAutoModule,
        PlatiRidicariAutoModule,
        DocumenteModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
